<script>
	export default {
		name: 'CertificationTypeListFilterMenu',
		props: {
			hideDeleted: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				menu: false,
				message: true,
				hints: true,
				fav: false
			};
		}
	};
</script>

<template>
	<div class="text-xs-center">
		<v-menu
			v-model="menu"
			:close-on-content-click="false"
			:nudge-width="200"
			offset-x
		>
			<template v-slot:activator="{ on }">
				<v-btn icon v-on="on"><v-icon>mdi-filter</v-icon> </v-btn>
			</template>

			<v-card>
				<v-card-title> Filters </v-card-title>

				<v-divider></v-divider>

				<v-list>
					<v-list-tile>
						<v-list-tile-action>
							<v-switch :value="!hideDeleted" color="primary" @change="$emit('toggleDeleted', !hideDeleted)"></v-switch>
						</v-list-tile-action>
						<v-list-tile-title>Show Archived</v-list-tile-title>
					</v-list-tile>
				</v-list>

			</v-card>
		</v-menu>
	</div>
</template>
